import {Injectable} from '@angular/core';

export interface BadgeItem {
  type: string;
  value: string;
}

export interface ChildrenItems {
  state: string;
  target?: boolean;
  name: string;
  type?: string;
  children?: ChildrenItems[];
}

export interface MainMenuItems {
  state: string;
  short_label?: string;
  main_state?: string;
  target?: boolean;
  name: string;
  type: string;
  icon: string;
  badge?: BadgeItem[];
  children?: ChildrenItems[];
}

export interface Menu {
  label: string;
  main: MainMenuItems[];
}

const MENUITEMS_ADMIN = [
  {
    label: '',
    main: [
      {
        state: 'dashboard',
        short_label: 'S',
        name: 'Dashboard',
        type: 'link',
        icon: 'ti-home'
      },
      {
        state: 'technician',
        short_label: 'S',
        name: 'Technician',
        type: 'link',
        icon: 'ti-cut'
      },
      {
        state: 'users',
        short_label: 'S',
        name: 'Users Management',
        type: 'link',
        icon: 'ti-user'
      },
      {
        state: 'vendor',
        short_label: 'S',
        name: 'Vendor',
        type: 'link',
        icon: 'ti-world'

      },
      {
        state: 'search',
        short_label: 'S',
        name: 'Search',
        type: 'link',
        icon: 'ti-search'
      },
      {
        state: 'shoppingcart',
        short_label: 'S',
        name: 'Shopping Carts',
        type: 'link',
        icon: 'ti-shopping-cart'
      },
      {
        state: 'rfqs',
        short_label: 'S',
        name: 'Request for Quote',
        type: 'link',
        icon: 'ti-receipt'
      },

    ]
  }
];

const MENUITEMS_PP = [
  {
    label: '',
    main: [
      {
        state: 'dashboard',
        short_label: 'S',
        name: 'Dashboard',
        type: 'link',
        icon: 'ti-home'
      },
      {
        state: 'technician',
        short_label: 'S',
        name: 'Technician',
        type: 'link',
        icon: 'ti-cut'
      },
      {
        state: 'vendor',
        short_label: 'S',
        name: 'Vendor',
        type: 'link',
        icon: 'ti-world'
      },
      {
        state: 'message-center',
        short_label: 'S',
        name: 'Message Center',
        type: 'link',
        icon: 'ti-comment-alt'
      },
      {
        state: 'shoppingcart',
        short_label: 'S',
        name: 'Shopping Carts',
        type: 'link',
        icon: 'ti-shopping-cart'
      },
      {
        state: 'search',
        short_label: 'S',
        name: 'Search',
        type: 'link',
        icon: 'ti-search'
      }
    ]
  }
];

const MENUITEMS_VENDOR = [
  {
    label: '',
    main: [
      {
        state: 'dashboard',
        short_label: 'S',
        name: 'Dashboard',
        type: 'link',
        icon: 'ti-home'
      },
      {
        state: 'users',
        short_label: 'S',
        name: 'Users Management',
        type: 'link',
        icon: 'ti-user'
      },
      {
        state: 'products',
        short_label: 'S',
        name: 'Products',
        type: 'sub',
        icon: 'ti-package',
        children: [
          {
            state: 'list',
            name: 'Product List'
          },
          {
            state: 'map-product',
            name: 'Product Bulk Upload'
          }
        ]
      },
      {
        state: 'message-center',
        short_label: 'S',
        name: 'Message Center',
        type: 'link',
        icon: 'ti-comment-alt'
       
      },
      {
        state: 'rfqs',
        short_label: 'S',
        name: 'Request for Quote',
        type: 'link',
        icon: 'ti-receipt'
      },
      {
        state: 'purchase-order',
        short_label: 'S',
        name: 'Purchase Orders',
        type: 'link',
        icon: 'ti-receipt'
      },
    ]
  }
];

const MENUITEMS_VENDOR_USER = [
  {
    label: '',
    main: [
      {
        state: 'dashboard',
        short_label: 'S',
        name: 'Dashboard',
        type: 'link',
        icon: 'ti-home'
      },
      {
        state: 'products',
        short_label: 'S',
        name: 'Products',
        type: 'sub',
        icon: ' ti-package',
        children: [
          {
            state: 'list',
            name: 'Product List'
          },
          {
            state: 'map-product',
            name: 'Product Bulk Upload'
          }
        ]
      },
      {
        state: 'rfqs',
        short_label: 'S',
        name: 'Request for Quote',
        type: 'link',
        icon: 'ti-receipt'
      },
    ]
  }
];

const MENUITEMS_DEVELOPER_ADMIN = [
  {
    label: '',
    main: [
      {
        state: 'dashboard',
        short_label: 'S',
        name: 'Dashboard',
        type: 'link',
        icon: 'ti-home'
      },

      {
        state: 'lookupTypes',
        short_label: 'S',
        name: 'Lookup Types',
        type: 'link',
        icon: 'ti-book'
      },

      {
        state: 'lookup',
        short_label: 'S',
        name: 'Lookups',
        type: 'link',
        icon: 'ti-eye'
      },
      {
        state: 'configuration',
        short_label: 'S',
        name: 'Configurations',
        type: 'link',
        icon: 'ti-light-bulb'
      },
      {
        state: 'emailTemplates',
        short_label: 'S',
        name: 'Email Templates',
        type: 'link',
        icon: 'ti-email'
      }

    ]
  }
];

@Injectable()
export class MenuItems {

  getAll(userRole: String): Menu[] {
    if(userRole == 'Admin' || userRole == 'SuperAdmin') {
      return MENUITEMS_ADMIN;
    } else if(userRole == 'Procurement Personal') {
      return MENUITEMS_PP;
    } else if(userRole == 'Vendor Admin' ) {
      return MENUITEMS_VENDOR;
    } else if(userRole == 'VUser') {
      return MENUITEMS_VENDOR_USER;
    } else if(userRole == 'DAdmin') {
      return MENUITEMS_DEVELOPER_ADMIN;
    } 
  }
}
